import { NgModule } from '@angular/core';
import { LocalConfigurationRepository } from './repositories/local-configuration-repository';

@NgModule({
  providers: [LocalConfigurationRepository],
})
export class LocalDbModule {}
